import { Alert, AlertDescription, AlertIcon, AlertTitle, Container, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import { H1 } from '@/components/Heading';
import NavLink from '@/components/UI/Links/NavLink';

import RoutePath from '@/constants/route-path';

export const RemindPasswordSent = () => {
    return (
        <Container maxW="2xl">
            <Alert
                status="success"
                variant="subtle"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                padding={6}
            >
                <AlertIcon boxSize="40px" mr={0} />

                <AlertTitle mt={4} mb={1} fontSize="lg">
                    <H1 size="h2">
                        <FormattedMessage id="page.remind-password.success"></FormattedMessage>
                    </H1>
                </AlertTitle>
                <AlertDescription maxWidth="sm">
                    <Text mx="auto" fontSize="sm">
                        <FormattedMessage id="page.remind-password.success.description"></FormattedMessage>
                    </Text>
                    <NavLink href={RoutePath.Home} variant="boldedBlue">
                        <FormattedMessage id="go-to-homepage" />
                    </NavLink>
                </AlertDescription>
            </Alert>
        </Container>
    );
};
